<div class="flex-direction-column height-100 page gap-15">
  <div>
    <app-card-cheduled
      [nomeAPi]="'API SCHEDULE'"
      [url]="scheduled"
    >
    </app-card-cheduled>
  </div>
  <div style="display: flex; gap: 1em; flex-wrap: wrap;">
    @for (tarefa of tarefas; track tarefa.id){
      <app-card-job
        [tarefa]="tarefa"
      >
      </app-card-job>
    }
  </div>
</div>
